<template>
    <div>
        <transition name="fade" appear>
            <div class="modal-overlay" v-if="showModal" @click="onClosed"></div>
        </transition>
        <transition name="slide" appear>
            <div class="modalX" v-if="showModal">
                <div class="button">
                    <i class="icofont-news iconedit"></i> <span v-html="input.header"></span>
                </div>
                <hr>
                <p v-html="input.body"> </p>
                <hr>
                <button class="button" @click="onClosed">
                    กดปิด
                </button>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "ModalX",
    props: {
        input: Object,
        showModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClosed(){
            this.$emit("closedModal")
        }
    }
}
</script>

<style lang="scss" scoped>



 .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 98;
    background-color: rgba(0, 0, 0, 0.3);
}

.modalX {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    
    width: 100%;
    max-width: 350px;
    // background-color: rgba(22, 150, 192, 0.945);
    // background-image: linear-gradient(#2E7D32, #0f5413) !important;
    background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%) !important;
    
    border-radius: 12px;
    padding: 35px;
    border: 2px solid #fff;
    
    h1 {
        color: rgb(248, 7, 7);
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 35px;
    }
 
    p {
        color: rgb(252, 249, 249);
        font-size: 15px;
        font-weight: 150;
        margin-bottom: 5px;
    }
}

.iconedit {
        color: #fff;
        font-size: 20px;
        font-weight: 200;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform .5s;
}

.slide-enter,
.slide-leave-to {
    transform: translateY(-50%) translateX(100vw);
}

.button {
 appearance: none;
 outline: none;
 border: none;
 background: none;
 cursor: pointer;
 
 display: inline-block;
 padding: 10px 10px;
 background-image: linear-gradient(to right, #CC2E5D, #FF5858);
 border-radius: 8px;
 
 color: #FFF;
 font-size: 18px;
 font-weight: 300;

 box-shadow: 3px 3px rgba(0, 0, 0, 0.4);
 transition: 0.4s ease-out;
 
 &:hover {
  box-shadow: 6px 6px rgba(0, 0, 0, 0.6);
 }
}
</style>